import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Settings as SettingsIcon, Users, Activity, CreditCard, ShieldCheck } from 'lucide-react';
import { InvestorMappingTool } from '@/components/admin/InvestorMappingTool';
import { InvestorOnboardingTracker } from '@/components/admin/InvestorOnboardingTracker';
import { GeneralSettings } from '@/components/settings/GeneralSettings';
import { RolesPermissionsGuide } from '@/components/settings/RolesPermissionsGuide';
import { useTenantStore } from '@/hooks/useTenantStore';
import PublicCompsSettings from '@/components/settings/PublicCompsSettings';
import BillingSettings from '@/components/settings/BillingSettings';
import TeamAccessSettings from '@/components/settings/TeamAccessSettings';

const Settings = () => {
  const { tenantId } = useTenantStore();

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
          <p className="text-muted-foreground">Manage your account and application settings</p>
        </div>

        <Tabs defaultValue="general" className="space-y-4">
          <TabsList className="grid w-full grid-cols-7">
            <TabsTrigger value="general">
              <SettingsIcon className="h-4 w-4 mr-2" />
              General
            </TabsTrigger>
            <TabsTrigger value="team-access">
              <Users className="h-4 w-4 mr-2" />
              Team & Access
            </TabsTrigger>
            <TabsTrigger value="roles-guide">
              <ShieldCheck className="h-4 w-4 mr-2" />
              Roles Guide
            </TabsTrigger>
            <TabsTrigger value="investor-mapping">
              <Users className="h-4 w-4 mr-2" />
              Investor Mapping
            </TabsTrigger>
            <TabsTrigger value="onboarding-tracker">
              <Activity className="h-4 w-4 mr-2" />
              Onboarding Tracker
            </TabsTrigger>
            <TabsTrigger value="public-comps">Public Comps</TabsTrigger>
            <TabsTrigger value="billing">
              <CreditCard className="h-4 w-4 mr-2" />
              Billing
            </TabsTrigger>
          </TabsList>

          <TabsContent value="general">
            <GeneralSettings />
          </TabsContent>

          <TabsContent value="team-access">
            {tenantId ? (
              <TeamAccessSettings companyId={tenantId} />
            ) : (
              <Card>
                <CardContent className="py-8">
                  <p className="text-center text-muted-foreground">
                    Please select a company to manage team access
                  </p>
                </CardContent>
              </Card>
            )}
          </TabsContent>

          <TabsContent value="roles-guide">
            <RolesPermissionsGuide />
          </TabsContent>

          <TabsContent value="investor-mapping">
            {tenantId ? (
              <InvestorMappingTool companyId={tenantId} />
            ) : (
              <Card>
                <CardContent className="py-8">
                  <p className="text-center text-muted-foreground">
                    Please select a company to manage investor mappings
                  </p>
                </CardContent>
              </Card>
            )}
          </TabsContent>

          <TabsContent value="onboarding-tracker">
            {tenantId ? (
              <InvestorOnboardingTracker companyId={tenantId} />
            ) : (
              <Card>
                <CardContent className="py-8">
                  <p className="text-center text-muted-foreground">
                    Please select a company to view onboarding tracker
                  </p>
                </CardContent>
              </Card>
            )}
          </TabsContent>

          <TabsContent value="public-comps">
            <PublicCompsSettings />
          </TabsContent>

          <TabsContent value="billing">
            {tenantId ? (
              <BillingSettings companyId={tenantId} />
            ) : (
              <Card>
                <CardContent className="py-8">
                  <p className="text-center text-muted-foreground">
                    Please select a company to manage billing
                  </p>
                </CardContent>
              </Card>
            )}
          </TabsContent>
        </Tabs>
      </div>
    </DashboardLayout>
  );
};

export default Settings;
